'use strict';

module.exports = require('./_eq')(function (a, b) { return a < b; });
